// extracted by mini-css-extract-plugin
export default {"wrapper":"TestimonialItem_wrapper__foDD1"};